import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=3d334062&scoped=true"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"
import style0 from "./ViewForm.vue?vue&type=style&index=0&id=3d334062&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d334062",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d334062')) {
      api.createRecord('3d334062', component.options)
    } else {
      api.reload('3d334062', component.options)
    }
    module.hot.accept("./ViewForm.vue?vue&type=template&id=3d334062&scoped=true", function () {
      api.rerender('3d334062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/audit/sku/components/ViewForm.vue"
export default component.exports